





















































































import Vue from 'vue'
import ZoomImg from './../../index'
import { component as VueCodeHighlight } from 'vue-code-highlight'
import 'vue-code-highlight/themes/duotone-sea.css'
import 'vue-code-highlight/themes/window.css'

const IMAGE_COUNT = 4

const getRandomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min
const getRandomString = () => (Math.floor(Math.random() * Math.floor(2)) === 1 ? 'gif' : 'c')

export default Vue.extend({
  name: 'Home',
  components: {
    VueCodeHighlight
  },
  directives: {
    ZoomImg
  },
  data() {
    return {
      images: Array.from(Array(IMAGE_COUNT).keys()).map(
        () => `https://www.placecage.com/${getRandomString()}/${getRandomInt(250, 350)}/${getRandomInt(150, 350)}`
      )
    }
  }
})
